import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  ISendLoginPayload,
  resetLogin as rdxResetLogin,
  selectLogin,
  sendLogin as rdxSendLogin,
  updateSocialToken as rdxUpdateSocialToken,
} from '../redux/login'

export default function useLogin() {
  const dispatch = useDispatch()

  const { data: login, isLoading, error, loginCompleted, socialToken } = useSelector(selectLogin)

  const sendLogin = useCallback(
    ({ userId, type, socialToken, username, password, recaptchaCode, middleware }: ISendLoginPayload) =>
      dispatch(rdxSendLogin({ userId, type, socialToken, username, password, recaptchaCode, middleware })),
    []
  )

  const updateSocialToken = useCallback((token: string) => dispatch(rdxUpdateSocialToken(token)), [])

  const resetLogin = useCallback(() => dispatch(rdxResetLogin()), [])

  return {
    login,
    isLoading,
    sendLogin,
    error,
    loginCompleted,
    socialToken,
    updateSocialToken,
    resetLogin,
  }
}
